<template>
    <div class="dia_container" v-loading="loading" element-loading-text="清理中，请稍候！">
        <div class="form_line">
            <label class="">请输入确认密码</label>
            <div class="cl password-set-line">
                <div class="l ml10">
                    <label class="l">确认密码<span class="red">*</span>：</label>
                    <div class="l ml10"><el-input v-model="password"></el-input></div>
                </div>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="save">清理</el-button>
        </div>
    </div>
</template>
<script>
    import { errorMessage } from '../../../util'
    export default {
        props: ['param'],
        data() {
            return {
                password: '',
                loading: false
            }
        },
        methods: {
            // 保存初始密码
            save() {
                if (!this.password) {
                    this.$message.warning('请输入确认密码！')
                    return
                }
                this.loading = true
                this.$http.post(`/platserv/metamodel/deleteAllData`,{
                    password: this.password,
                    tenantcode: this.param.tenantCode
                }).then(function(res){
                    this.loading = false
                    this.$message.success('清理成功！')
                    this.cancel()
                }).catch(error => {
                    this.loading = false
                    errorMessage(error, this)
                })
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ConfirmClearMetadata.vue?12a2a8d6